import { useMutation } from '@tanstack/react-query';
import { API } from 'api';
import { DOMAINS, IMPORTANCE } from '@repo/monitoring';

import { apiBasePath, apiName } from 'assets/constants';

export interface AudienceFeedbackPayload {
  kitId: string;
  question: string;
  answer: string;
  type: string;
  extraInfo?: Record<string, unknown>;
  // Name of the calling component, for monitoring context.
  component: string;
}

const createAudienceFeedback = ({
  kitId,
  question,
  answer,
  type,
  extraInfo,
  component,
}: AudienceFeedbackPayload) =>
  API.post(
    apiName,
    `${apiBasePath}/audienceFeedback/${kitId}`,
    {
      question,
      answer,
      type,
      extra_info: extraInfo ?? null,
    },
    true,
    undefined,
    {
      tags: {
        domain: DOMAINS.FEEDBACK,
        importance: IMPORTANCE.MEDIUM,
      },
      context: {
        kitId,
        component,
        feedbackType: type,
        question,
      },
    },
  );

// No overlay-answers invalidation on success: refetching mid-flow would make
// AudienceFeedbackOverlay hide itself before the remaining questions.
const useCreateAudienceFeedback = () =>
  useMutation({ mutationFn: createAudienceFeedback });

export default useCreateAudienceFeedback;
